/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import Utr from '../../../text/Utr';
import PlayerLookupInput from './PlayerLookupInput';
import { getPlayerName } from '../../../../utils';

import styles from '../playerSelect.scss';

const PlayerSelect = (props) => {
    const {
        drawFormatType,
        match,
        playerOptions,
        playersDict,
        utrType,
        allowPlayerChange,
        showBye,
        position,
        onSelect,
        teamName,
        showTeamName,
        doNotMask = true,
        sportTypeId,
        'data-testid': dataTestId,
    } = props;

    function utrById(playerId) {
        const player = playersDict[playerId];
        return <Utr player={player} pbrClass={styles.pbr} force={{ ratingType: drawFormatType.value, utrType, showDecimals: true, doNotMask }} sportTypeId={sportTypeId} data-testid={dataTestId && `${dataTestId}.utr-${playerId}`} />;
    }

    let name; let
        nameMobile;
    if (match[position] && match[position].id && match[position].type && match[position].type.value === 'player') {
        const selectedPlayer = playersDict[match[position].id];
        const seed = match[`${position}Seed`];
        name = selectedPlayer ? <span className="selected-name">{seed && <small className="selected-seed">{seed}</small>}{selectedPlayer.displayName}<small> {utrById(selectedPlayer.id)}</small></span> : '';
        nameMobile = selectedPlayer ? <span className="selected-name">{seed && <small className="selected-seed">{seed}</small>}{getPlayerName(selectedPlayer.firstName, selectedPlayer.lastName, true)}<small> {utrById(selectedPlayer.id)}</small></span> : '';
    } else if (match[position] && match[position].type && match[position].type.value === 'bye') {
        name = 'Bye';
        nameMobile = 'Bye';
    } else {
        name = 'Select a player';
        nameMobile = 'Select a player';
    }

    let selectClass;
    if (!(match[position] && match[position].id)) {
        if (match[position] && match[position].type && match[position].type.value === 'bye') {
            selectClass = 'bye';
        } else {
            selectClass = 'empty';
        }
    } else if (match[position].type && match[position].type.value === 'bye') {
        selectClass = 'bye';
    }

    return (
        <React.Fragment>
            <PlayerLookupInput
                {...props}
                name={name}
                selectClass={`${selectClass} ${position === 'position2' ? 'mb2' : ''}`}
                utrById={utrById}
                teamName={teamName}
                showTeamName={showTeamName}
                parentClass={`d-none d-md-block`}
                data-testid={dataTestId && `${dataTestId}.desktop`}
            />
            <PlayerLookupInput
                {...props}
                name={nameMobile}
                selectClass={`${selectClass} ${position === 'position2' ? 'mb2' : ''}`}
                utrById={utrById}
                teamName={teamName}
                showTeamName={showTeamName}
                isMobile={true}
                parentClass={`d-block d-md-none player-lookup-mobile`}
                data-testid={dataTestId && `${dataTestId}.mobile`}
            />
        </React.Fragment>
    );
};

PlayerSelect.propTypes = {
    'data-testid': PropTypes.string,
};

PlayerSelect.defaultProps = {
    'data-testid': null,
};

export default PlayerSelect;
